import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from "vue";
import { cloneDeep } from "lodash-es";
import gql from "fraql";
import dayjs from "@/plugins/dayjs";
export default /*@__PURE__*/ _defineComponent({
    ...{
        name: "AppShowActivityLogs",
        fragments: {
            activityLogFields: gql `
      fragment _ on ActivityLog {
        id
        activityName
        actorPerson {
          id
          name
        }
        createdAt
      }
    `
        }
    },
    __name: 'AppShowActivityLogs',
    props: {
        activityLogs: {},
        typename: {}
    },
    setup(__props) {
        const props = __props;
        // sort by earliest first
        const timestamps = computed(() => cloneDeep(props.activityLogs).sort((a, b) => dayjs(a.createdAt).isBefore(b.createdAt) ? -1 : 1));
        const defaultTexts = {
            submitted: "Submitted",
            reserved: "Put to reserve",
            selected: "Selected",
            not_selected: "Not selected",
            withdrawn: "Withdrawn",
            reopened_as_candidate: "Set as candidate",
            removed: "Deleted",
            restored: "Undeleted"
        };
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", null, [
                (_ctx.typename == 'PersonEventStaffFunction')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(timestamps.value, (timestamp) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: timestamp.id,
                            class: "activity-log-timestamp"
                        }, [
                            _createTextVNode(_toDisplayString(_ctx.$t(`events:staffRecruitment.manageCandidates.candidatesList.activityLogs.${timestamp.activityName}.label`, defaultTexts[timestamp.activityName])) + ": " + _toDisplayString(_ctx.$dayjs.date(timestamp.createdAt, "fullTime")) + " ", 1),
                            (timestamp.actorPerson)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: {
                                        name: 'PersonProfilePage',
                                        params: { personId: timestamp.actorPerson.id }
                                    },
                                    target: "_blank"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("(" + _toDisplayString(timestamp.actorPerson.name) + ")", 1)
                                    ]),
                                    _: 2
                                }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
